import type { SortOptions } from '@tunasong/models'
import { defaultSortOptions as defSortOptions } from '@tunasong/models'
import type { EntityType } from '@tunasong/schemas'
import { useDeviceState } from '../util/device-state.hook.js'

/** Use device state for sort options and filter */
export const useSortFilterOptions = (
  optionsKey: string = 'default',
  {
    defaultFilter = [],
    defaultSortOptions = defSortOptions,
  }: { defaultFilter?: EntityType[]; defaultSortOptions?: SortOptions } | undefined = {}
) => {
  const [sortOptions = defaultSortOptions, setSortOptions] = useDeviceState<SortOptions>(
    `entities.${optionsKey}.sort`,
    defaultSortOptions
  )
  const [filter = [], setFilter] = useDeviceState<EntityType[]>(`entities.${optionsKey}.filter`, defaultFilter)

  return {
    sortOptions,
    setSortOptions,
    filter,
    setFilter,
  }
}
